import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EFConnectableSide, FFlowModule } from '@foblex/flow';
import { ViewPort } from '../../models';

@Component({
  selector: 'iot-platform-ui-flow-output',
  imports: [FFlowModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      data-test="iot-platform-ui-flow-output"
      fConnector
      fConnectorType="source"
      [fConnectorMultiple]="!!output()?.multiple"
      [fConnectorId]="output().id"
      [fConnectorConnectableSide]="output()?.position ?? EFConnectableSide.RIGHT"
      class="{{ output()?.position ?? EFConnectableSide.RIGHT }} {{ output()?.cssClassName }}"
    ></div>
  `
})
export class FlowOutputComponent {
  output = input.required<ViewPort>();
  protected readonly EFConnectableSide = EFConnectableSide;
}
